export default __webpack_public_path__ + "ea673170118095ed1169bda537f09003.png";